import { render, staticRenderFns } from "./AccordionPager.vue?vue&type=template&id=0310c942&scoped=true&"
import script from "./AccordionPager.vue?vue&type=script&lang=js&"
export * from "./AccordionPager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310c942",
  null
  
)

export default component.exports